import { VTreeSelectItem } from '@voly/ui-components/src/v2/VTreeSelect/VTreeSelect';
import { TCustomFieldList } from 'src/app/project/modules/custom-fields/custom-fields.model';

export const toTreeItems = (list: TCustomFieldList[]): VTreeSelectItem[] =>
  list.flatMap((item) => {
    if (!item.id) {
      return [];
    }

    return [
      {
        id: item.id,
        label: item.label,
        children: item.subList?.length ? toTreeItems(item.subList) : undefined,
      },
    ];
  });
